import { Position } from '@oai-frontend-monorepo/types';
import SymbolParser from '../symbol/SymbolParser';

export const parseUnderlyingSymbolFromPosition = (position?: Position) => {
  if (!position) {
    return undefined;
  }

  return new SymbolParser(position.legPositions?.[0]?.symbol).underlyingSymbol;
};
